















import { Component, Vue } from "vue-property-decorator";
import ThgPriceTable from "@/components/thg/ThgPriceTable.vue";
import ThgPromotionTable from "@/components/thg/ThgPromotionTable.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";

@Component({
  components: {
    TheLayoutPortal,
    ThgPriceTable,
    ThgPromotionTable
  },
  filters: {}
})
export default class ThgPriceTableView extends Vue {
  selectedTab = 0;
}
